import { TdProps } from 'app/common/ui-components/table'

import {
  AGE_GROUP_ROW_KEY_PREFIX,
  ALLOWANCE_ROW_KEY_PREFIX,
  KLASSES_ALLOWANCE_ROW_KEY_PREFIX,
  SECTION_ROW_KEY_PREFIX,
} from './data'
import { Entity } from './types'

const defaultCellsProps = {
  [Entity.Count]: { alignLeft: true, width: 80 },
  [Entity.Category]: { alignLeft: true, minWidth: 350 },
  [Entity.Students]: { alignRight: true },
  [Entity.Compensation]: { alignRight: true },
  [Entity.TotalRow]: { alignRight: true },
}

export const createDataProps = () => {
  return new Proxy(defaultCellsProps, {
    get: function (target, property) {
      return target[property as string] || {}
    },
  })
}

export const createTdPropsByRowAndColumnKey = () => {
  return ({
    rowKey,
    columnKey,
  }: {
    side: 'left' | 'right' | 'main'
    rowKey: string
    columnKey: string
  }) => {
    const props = {
      style: { verticalAlign: 'top' },
    } as Omit<TdProps, 'children' | 'className'>
    const isSectionRow = rowKey.startsWith(SECTION_ROW_KEY_PREFIX)
    const isSecondLevelRow = rowKey.startsWith(ALLOWANCE_ROW_KEY_PREFIX)
    const isKlassesAllowanceRow = rowKey.startsWith(KLASSES_ALLOWANCE_ROW_KEY_PREFIX)
    const isThirdLevelRow = rowKey.startsWith(AGE_GROUP_ROW_KEY_PREFIX)

    if (isSectionRow) {
      props.style = { ...props.style, fontWeight: '500' }
    }

    if (isSectionRow) {
      if (columnKey === Entity.Category) {
        props.colSpan = 4
      }

      if (
        columnKey === Entity.Students ||
        columnKey === Entity.Compensation ||
        columnKey === Entity.TotalRow
      ) {
        props.hidden = true
      }
    }

    if (isSecondLevelRow) {
      if (columnKey === Entity.Category) {
        props.colSpan = 4
      }

      if (
        columnKey === Entity.Students ||
        columnKey === Entity.Compensation ||
        columnKey === Entity.TotalRow
      ) {
        props.hidden = true
      }
    }

    if (columnKey === Entity.Category) {
      if (isSecondLevelRow || isKlassesAllowanceRow) {
        props.style = { ...props.style, paddingLeft: '15px' }
      }

      if (isThirdLevelRow) {
        props.style = { ...props.style, paddingLeft: '30px' }
      }
    }

    return props
  }
}
